var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { hasClass, addClass, getParentWithClass, removeClass } from '@/support/Html';
import { Subject } from '@/models/Subject';
let DescriptionColumn = class DescriptionColumn extends Vue {
    hideFullDescription(event, closeClick = false) {
        const target = event.target;
        let popout;
        if (closeClick) {
            popout = getParentWithClass(target, 'descriptionColumn__popout');
        }
        else {
            popout = target.querySelectorAll('.descriptionColumn__popout')[0];
        }
        if (popout !== null) {
            removeClass(popout, 'show');
        }
    }
    showFullDescription(event) {
        const target = event.target;
        if (hasClass(target, 'descriptionColumn__popout')) {
            return;
        }
        const td = target;
        const popout = target.querySelectorAll('.descriptionColumn__popout')[0];
        addClass(popout, 'show');
    }
    onOpenSubjectDialogButtonClick() {
        this.$emit('openSubjectDialog');
    }
    get subjectName() {
        return this.subject.name || '';
    }
    get subjectParentName() {
        return this.subject.parent
            && this.subject.parent
            && typeof this.subject.parent !== 'string'
            && this.subject.parent.name
            ? this.subject.parent.name
            : '';
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], DescriptionColumn.prototype, "subject", void 0);
DescriptionColumn = __decorate([
    Component({})
], DescriptionColumn);
export default DescriptionColumn;
